import { ApolloQueryResult, FetchResult, MutationResult } from '@apollo/client';
import { useContext, useState } from 'react';
import { SEVERITY, ToastDispatchContext } from '../../toast/Toast';

import { ErrorData, ErrorFormatter } from './error-formatter';
import { ClientLogger } from '../client-logger';

export function useErrorHandling(location: string) {
  const toastDispatch = useContext(ToastDispatchContext);
  const [errorData, setErrorData] = useState<ErrorData | undefined>(undefined);

  function handleErrors(newErrorData: ErrorData, toastFlag?: boolean) {
    setErrorData(newErrorData);
    const errors = new ErrorFormatter(newErrorData);
    ClientLogger.error(location, errors.displayErrors());
    toastFlag && toastDispatch({ msg: errors.displayErrors(), severity: SEVERITY.ERROR, autoClose: true });
  }

  function handleQueryResponse(result: ApolloQueryResult<any>) {
    if (result.error) {
      handleErrors({ apolloErrors: result.error, graphQLErrors: result.errors });
    }
    if (result.errors) {
      handleErrors({ graphQLErrors: result.errors });
    }
  }

  function handleMutationResponse(result: FetchResult<any>, toastFlag?: boolean) {
    if (result.errors) {
      handleErrors({ graphQLErrors: result.errors }, toastFlag);
    }
  }

  return { errorData, handleErrors, handleQueryResponse, handleMutationResponse };
}
